var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sui-grid',{attrs:{"centered":""}},[_c('sui-grid-row',[_c("sui-image",{tag:"a",attrs:{"href":"","target":"_blank","src":_vm.logo,"size":"small"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }